import { createI18n } from 'vue-i18n'

import loadMessages from '../translations/messages.js'

const messages = loadMessages()
const preferredLocale = window.vue_lang || 'en'
const fallbackLocale = messages.en ? 'en' : Object.keys(messages)[0] || 'en'
const activeLocale = messages[preferredLocale]
  ? preferredLocale
  : fallbackLocale

const i18n = createI18n({
  legacy: false, // you must set `legacy: false` to use the Composition API
  globalInjection: true, // enable global injection
  locale: activeLocale,
  fallbackLocale,
  messages,
  warnHtmlMessage: false // Disable HTML warnings in translation messages
})

export default i18n
